import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { ICONS_AND_PATH } from './shared/data/data'
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'alterna-admin';

  showTestBanner = false;

  constructor(
    private translate: TranslateService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {
    const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
    this.showTestBanner =
      hostname === 'localhost' ||
      hostname === '127.0.0.1' ||
      hostname === 'test.alternacultivacionapp.com';

    ICONS_AND_PATH.forEach(({ name, path }) =>
      this.iconRegistry
        .addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(path))
    );
    this.translate.setDefaultLang('es');
    this.translate.use('es');
  };
}
